import React from 'react';
import Head from '../components/Header';
import FootNote from '../components/Footer';
import { ConfigProvider, theme, Layout } from 'antd';
import { useSiteContext } from '../context/SiteContext'
import { Outlet } from 'react-router-dom';
const { Content } = Layout;

const LayoutStructure = () => {
  const { isDarkMode } = useSiteContext()
  const backgroundColor = isDarkMode ? '#212529' : '#fcfcf4';
  const textColor = isDarkMode ? '#fcfcf4' : '#212529';

  return (
    <ConfigProvider
      theme={{
        algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
          colorPrimary: '#e7aa11',
          colorInfo: '#e7aa11',
        },
      }}
    >
      <div
        style={{
          backgroundColor,
          color: textColor,
        }}
      >
        <Layout>
          <Head />
          <Content>
            {/* Breadcrumb goes here */}
            <Layout>
              {/* Sider goes here */}
              <Content className='min-h-[calc(100vh-133px)] lg:min-h-[calc(100vh-112px)]'>
                <Outlet />
              </Content>
            </Layout>
          </Content>
          <FootNote />
        </Layout>
      </div>
    </ConfigProvider>
  );
};

export default LayoutStructure;
